import {memo, useEffect} from 'react'

import type {BeforeInstallPromptEvent} from '../../@types/BeforeInstallPromptEvent.ts'
import {useSetInstallPrompt} from '../states/installPrompt.ts'

export const InstallPromptListener = memo(function InstallPromptListener() {
  const setInstallPrompt = useSetInstallPrompt()

  useEffect(() => {
    if (window.verticaltopo?.beforeinstallprompt) {
      setInstallPrompt(window.verticaltopo.beforeinstallprompt)
    }

    const installPromptHandler = (event: BeforeInstallPromptEvent) => {
      event.preventDefault()
      setInstallPrompt(event)
    }
    const installedAppHandler = () => {
      setInstallPrompt(undefined)
    }

    const controller = new AbortController()
    window.addEventListener('beforeinstallprompt', installPromptHandler, {signal: controller.signal})
    window.addEventListener('appinstalled', installedAppHandler, {signal: controller.signal})

    return () => {
      setInstallPrompt(undefined)
      controller.abort()
    }
  }, [setInstallPrompt])

  return null
})
